import { useMemo, useState, useEffect, useCallback, useRef } from "react";
import {
  useGetKnowledgeBaseDocumentsQuery,
  useDeleteKnowledgeBaseDocumentMutation,
  useLazyGetKnowledgeBaseDocumentPreviewUrlQuery,
} from "../../../../../../../../redux/services/helpdeskApi";
import { createPortal } from "react-dom";
import { ColumnDef } from "@tanstack/react-table";
import Table from "../../../../../../../../components/Table/Table";
import Pagination from "../../../../../../../../components/Table/Pagination";
import SearchIcon from "../../../../../../../../assets/svg/search-icon";
import GalleryIcon from "../../../../../../../../assets/svg/gallery-icon";
import SortByIcon from "../../../../../../../../assets/svg/sort-by-icon";
import ThreeDotsVerticalIcon from "../../../../../../../../assets/svg/three-dots-vertical-icon";
import PreviewIcon from "../../../../../../../../assets/svg/preview-icon";
import ReUploadIcon from "../../../../../../../../assets/svg/re-upload-icon";
import TrashIcon from "../../../../../../../../assets/svg/trash-icon";
import Button from "../../../../../../../../components/Button/Button";
import { getFileTypeIcon } from "../../../../../../../../utils/functions/file-icon-extractor";
import { Avatar } from "../../../../../../../../components/Avatar/Avatar";
import CheckIcon from "../../../../../../../../assets/svg/check-icon";
import DeleteDocumentModal from "../../../../../../../Playground/components/KnowledgeBase/components/Documents/DeleteDocumentModal";
import DocPreviewer from "../../../../../../../Playground/components/KnowledgeBase/components/DocPreviewer";
import { getDateTimeByFormat } from "../../../../../../../../redux/slices/dateTimeFormatSlice";
import { usePersistedPagination } from "../../../../../../../../hooks/usePersistedPagination";
import { useSessionStorageState } from "../../../../../../../../utils/storage/storageUtils";
import { SystemName, renderSystemIcon } from "../../utils/categoryIcons";
import { KnowledgeBaseDocumentAPI, HelpDeskDocument } from "../../utils/types";
import DownloadIcon from "../../../../../../../../assets/svg/download-icon";

export type { SystemName };

// const DUMMY_DOCUMENTS: HelpDeskDocument[] = [
//   {
//     id: "1",
//     fileName: "Concurrent FAQs.doc",
//     systemName: "Concurrent",
//     fileSize: "14.67 KB",
//     uploadedBy: "Sparsh Gupta",
//     uploadedAt: "01 Dec 2023, 01:30 PM",
//   },
//   {
//     id: "2",
//     fileName: "Stargo Frontier Report.pdf",
//     systemName: "PRISM",
//     fileSize: "14.67 KB",
//     uploadedBy: "Liam Neeson",
//     uploadedAt: "01 Dec 2023, 01:30 PM",
//   },
//   {
//     id: "3",
//     fileName: "Celestial Navigation Guide.doc",
//     systemName: "PowerBI",
//     fileSize: "14.67 KB",
//     uploadedBy: "Sparsh Gupta",
//     uploadedAt: "01 Dec 2023, 01:30 PM",
//   },
//   {
//     id: "4",
//     fileName: "Concurrent FAQs.pdf",
//     systemName: "HubSpot",
//     fileSize: "20.45 KB",
//     uploadedBy: "Maya Thompson",
//     uploadedAt: "02 Dec 2023, 10:15 AM",
//   },
//   {
//     id: "5",
//     fileName: "Design Specifications.doc",
//     systemName: "HubSpot",
//     fileSize: "18.20 KB",
//     uploadedBy: "Liam Brown",
//     uploadedAt: "03 Dec 2023, 02:50 PM",
//   },
//   {
//     id: "6",
//     fileName: "Market Analysis.pdf",
//     systemName: "PowerBI",
//     fileSize: "25.30 KB",
//     uploadedBy: "Emma Johnson",
//     uploadedAt: "04 Dec 2023, 09:00 AM",
//   },
//   {
//     id: "7",
//     fileName: "Sprint Planning.pdf",
//     systemName: "HubSpot",
//     fileSize: "15.75 KB",
//     uploadedBy: "Noah Williams",
//     uploadedAt: "05 Dec 2023, 11:45 AM",
//   },
//   {
//     id: "8",
//     fileName: "Competitor Analysis.doc",
//     systemName: "PowerBI",
//     fileSize: "30.80 KB",
//     uploadedBy: "Olivia Martinez",
//     uploadedAt: "06 Dec 2023, 03:20 PM",
//   },
//   {
//     id: "9",
//     fileName: "Performance Metrics.doc",
//     systemName: "HubSpot",
//     fileSize: "22.60 KB",
//     uploadedBy: "Ethan Davis",
//     uploadedAt: "07 Dec 2023, 08:30 AM",
//   },
//   {
//     id: "10",
//     fileName: "User Persona Development.doc",
//     systemName: "New User Access",
//     fileSize: "19.90 KB",
//     uploadedBy: "Ava Taylor",
//     uploadedAt: "08 Dec 2023, 10:05 AM",
//   },
//   {
//     id: "11",
//     fileName: "Project Timeline.pdf",
//     systemName: "Concurrent",
//     fileSize: "12.30 KB",
//     uploadedBy: "Sparsh Gupta",
//     uploadedAt: "09 Dec 2023, 02:00 PM",
//   },
//   {
//     id: "12",
//     fileName: "API Documentation.doc",
//     systemName: "PRISM",
//     fileSize: "45.20 KB",
//     uploadedBy: "Liam Brown",
//     uploadedAt: "10 Dec 2023, 09:30 AM",
//   },
//   {
//     id: "13",
//     fileName: "Sales Report Q4.pdf",
//     systemName: "HubSpot",
//     fileSize: "32.10 KB",
//     uploadedBy: "Emma Johnson",
//     uploadedAt: "11 Dec 2023, 11:00 AM",
//   },
//   {
//     id: "14",
//     fileName: "Data Migration Plan.doc",
//     systemName: "PowerBI",
//     fileSize: "28.50 KB",
//     uploadedBy: "Noah Williams",
//     uploadedAt: "12 Dec 2023, 03:45 PM",
//   },
//   {
//     id: "15",
//     fileName: "Onboarding Guide.pdf",
//     systemName: "New User Access",
//     fileSize: "16.80 KB",
//     uploadedBy: "Ava Taylor",
//     uploadedAt: "13 Dec 2023, 10:15 AM",
//   },
//   {
//     id: "16",
//     fileName: "Brand Guidelines.doc",
//     systemName: "Concurrent",
//     fileSize: "38.90 KB",
//     uploadedBy: "Maya Thompson",
//     uploadedAt: "14 Dec 2023, 01:00 PM",
//   },
//   {
//     id: "17",
//     fileName: "Infrastructure Overview.pdf",
//     systemName: "PRISM",
//     fileSize: "21.40 KB",
//     uploadedBy: "Ethan Davis",
//     uploadedAt: "15 Dec 2023, 04:30 PM",
//   },
//   {
//     id: "18",
//     fileName: "Customer Feedback Summary.doc",
//     systemName: "HubSpot",
//     fileSize: "17.60 KB",
//     uploadedBy: "Olivia Martinez",
//     uploadedAt: "16 Dec 2023, 09:00 AM",
//   },
//   {
//     id: "19",
//     fileName: "Security Audit Report.pdf",
//     systemName: "Feature Requests",
//     fileSize: "42.30 KB",
//     uploadedBy: "Sparsh Gupta",
//     uploadedAt: "17 Dec 2023, 02:15 PM",
//   },
//   {
//     id: "20",
//     fileName: "Release Notes v2.0.doc",
//     systemName: "Concurrent",
//     fileSize: "11.50 KB",
//     uploadedBy: "Liam Neeson",
//     uploadedAt: "18 Dec 2023, 11:30 AM",
//   },
//   {
//     id: "21",
//     fileName: "Training Manual.pdf",
//     systemName: "New User Access",
//     fileSize: "55.00 KB",
//     uploadedBy: "Emma Johnson",
//     uploadedAt: "19 Dec 2023, 08:45 AM",
//   },
//   {
//     id: "22",
//     fileName: "Integration Testing.doc",
//     systemName: "PRISM",
//     fileSize: "24.70 KB",
//     uploadedBy: "Noah Williams",
//     uploadedAt: "20 Dec 2023, 03:00 PM",
//   },
//   {
//     id: "23",
//     fileName: "Revenue Dashboard.pdf",
//     systemName: "PowerBI",
//     fileSize: "33.20 KB",
//     uploadedBy: "Ava Taylor",
//     uploadedAt: "21 Dec 2023, 10:30 AM",
//   },
//   {
//     id: "24",
//     fileName: "Product Roadmap.doc",
//     systemName: "Feature Requests",
//     fileSize: "19.10 KB",
//     uploadedBy: "Maya Thompson",
//     uploadedAt: "22 Dec 2023, 01:45 PM",
//   },
//   {
//     id: "25",
//     fileName: "CRM Setup Guide.pdf",
//     systemName: "HubSpot",
//     fileSize: "27.80 KB",
//     uploadedBy: "Ethan Davis",
//     uploadedAt: "23 Dec 2023, 09:15 AM",
//   },
//   {
//     id: "26",
//     fileName: "Employee Handbook.doc",
//     systemName: "New User Access",
//     fileSize: "48.60 KB",
//     uploadedBy: "Olivia Martinez",
//     uploadedAt: "24 Dec 2023, 02:30 PM",
//   },
//   {
//     id: "27",
//     fileName: "Analytics Dashboard Guide.pdf",
//     systemName: "PowerBI",
//     fileSize: "35.40 KB",
//     uploadedBy: "Sparsh Gupta",
//     uploadedAt: "25 Dec 2023, 11:00 AM",
//   },
//   {
//     id: "28",
//     fileName: "Deployment Checklist.doc",
//     systemName: "PRISM",
//     fileSize: "13.90 KB",
//     uploadedBy: "Liam Brown",
//     uploadedAt: "26 Dec 2023, 04:00 PM",
//   },
//   {
//     id: "29",
//     fileName: "Customer Success Playbook.pdf",
//     systemName: "HubSpot",
//     fileSize: "29.50 KB",
//     uploadedBy: "Emma Johnson",
//     uploadedAt: "27 Dec 2023, 08:30 AM",
//   },
//   {
//     id: "30",
//     fileName: "Feature Specification.doc",
//     systemName: "Feature Requests",
//     fileSize: "22.00 KB",
//     uploadedBy: "Noah Williams",
//     uploadedAt: "28 Dec 2023, 01:15 PM",
//   },
//   {
//     id: "31",
//     fileName: "Quarterly Business Review.pdf",
//     systemName: "Concurrent",
//     fileSize: "41.20 KB",
//     uploadedBy: "Ava Taylor",
//     uploadedAt: "29 Dec 2023, 10:00 AM",
//   },
//   {
//     id: "32",
//     fileName: "System Architecture.doc",
//     systemName: "PRISM",
//     fileSize: "36.70 KB",
//     uploadedBy: "Maya Thompson",
//     uploadedAt: "30 Dec 2023, 03:30 PM",
//   },
//   {
//     id: "33",
//     fileName: "Marketing Strategy.pdf",
//     systemName: "HubSpot",
//     fileSize: "26.40 KB",
//     uploadedBy: "Ethan Davis",
//     uploadedAt: "31 Dec 2023, 09:45 AM",
//   },
//   {
//     id: "34",
//     fileName: "Incident Response Plan.doc",
//     systemName: "Concurrent",
//     fileSize: "18.30 KB",
//     uploadedBy: "Olivia Martinez",
//     uploadedAt: "01 Jan 2024, 02:00 PM",
//   },
//   {
//     id: "35",
//     fileName: "User Access Matrix.pdf",
//     systemName: "New User Access",
//     fileSize: "15.20 KB",
//     uploadedBy: "Sparsh Gupta",
//     uploadedAt: "02 Jan 2024, 11:15 AM",
//   },
// ];
interface ActionOption {
  innerText: string;
  Icon: React.FC<React.SVGProps<SVGSVGElement>> | React.FC;
  iconClass: string;
  innerTextClass: string;
  buttonContainerClass: string;
  onClick: () => void;
}

const getPopupHeight = (actionCount: number) => {
  let height = 24;
  height += actionCount * 40;
  height += (actionCount - 1) * 4;
  return Math.min(height, 350);
};

const calculatePopupPosition = (
  rect: DOMRect,
  scrollLeft: number,
  scrollTop: number,
  viewportHeight: number,
  popupHeight: number,
  popupWidth: number
) => {
  const spaceBelow = viewportHeight - rect.bottom;
  const spaceAbove = rect.top;
  const x = rect.left + scrollLeft - popupWidth;
  let y;
  if (spaceBelow < popupHeight && spaceAbove > spaceBelow) {
    y = rect.top + scrollTop - popupHeight + 35;
  } else {
    y = rect.bottom + scrollTop + 4;
  }
  return { x, y };
};

const ActionsCellComponent = ({
  rowId,
  isOpen,
  setOpenMenuId,
  actionOptions,
}: {
  rowId: string;
  isOpen: boolean;
  setOpenMenuId: (id: string | null) => void;
  actionOptions: ActionOption[];
}) => {
  const buttonRef = useRef<HTMLDivElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);
  const [popupPosition, setPopupPosition] = useState<{
    x: number;
    y: number;
  } | null>(null);

  const toggle = (e: React.MouseEvent) => {
    e?.stopPropagation();
    e?.preventDefault();
    setOpenMenuId(isOpen ? null : rowId);
  };

  useEffect(() => {
    if (isOpen && buttonRef.current && actionOptions?.length > 0) {
      const rect = buttonRef?.current?.getBoundingClientRect();
      const scrollTop =
        window.pageYOffset || document?.documentElement?.scrollTop;
      const scrollLeft =
        window.pageXOffset || document?.documentElement?.scrollLeft;
      const viewportHeight = window.innerHeight;
      const popupHeight = getPopupHeight(actionOptions?.length);
      const popupWidth = popupRef?.current?.offsetWidth ?? 180;
      setPopupPosition(
        calculatePopupPosition(
          rect,
          scrollLeft,
          scrollTop,
          viewportHeight,
          popupHeight,
          popupWidth
        )
      );
    }
  }, [isOpen, actionOptions?.length]);

  useEffect(() => {
    if (isOpen) {
      const handleClickOutside = (e: MouseEvent) => {
        if (
          popupRef.current &&
          !popupRef.current.contains(e.target as Node) &&
          buttonRef.current &&
          !buttonRef.current.contains(e.target as Node)
        ) {
          setOpenMenuId(null);
        }
      };
      const handleScroll = (e: Event) => {
        e?.preventDefault();
        e?.stopPropagation();
      };

      document.addEventListener("mousedown", handleClickOutside);
      window.addEventListener("scroll", handleScroll, {
        passive: false,
        capture: true,
      });
      window.addEventListener("wheel", handleScroll, {
        passive: false,
        capture: true,
      });

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        window.removeEventListener("scroll", handleScroll, true);
        window.removeEventListener("wheel", handleScroll, true);
      };
    }
  }, [isOpen, setOpenMenuId]);

  return (
    <div className="relative h-full flex items-center justify-center px-2">
      <div
        ref={buttonRef}
        data-three-dots-button
        className="flex items-center justify-center p-1 rounded-md cursor-pointer hover:bg-hover-effect dark:hover:bg-hover-effect-dk transition-colors duration-200"
        onClick={toggle}
      >
        <ThreeDotsVerticalIcon className="w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk" />
      </div>
      {isOpen &&
        actionOptions?.length > 0 &&
        popupPosition &&
        createPortal(
          <div
            ref={popupRef}
            className="fixed z-100 min-w-[180px] py-2 bg-popper-bg dark:bg-popper-bg-dk backdrop-blur-[10px] border border-border-gray dark:border-border-gray-dk rounded-[8px] shadow-popper-blur-effect flex flex-col gap-2 transition-all duration-200"
            style={{ left: popupPosition.x, top: popupPosition.y }}
            data-popup-content
          >
            {actionOptions?.map((action, index) => (
              <div
                key={index}
                className="hover:bg-hover-effect dark:hover:bg-hover-effect-dk transition-colors duration-200 px-1 py-1"
              >
                <Button
                  innerText={action.innerText}
                  Icon={action.Icon}
                  iconClass={action.iconClass}
                  innerTextClass={action.innerTextClass}
                  buttonContainerClass={action.buttonContainerClass}
                  iconLeft
                  onClick={action.onClick}
                />
              </div>
            ))}
          </div>,
          document.body
        )}
    </div>
  );
};

interface ManageDocumentsTableProps {
  title?: string;
  systemNameFilter?: SystemName;
  categoryFilter?: string;
  categoriesData?: { id: string; title: string }[];
}

const formatFileSize = (sizeInKbs: number): string => {
  if (!sizeInKbs) return "-";
  if (sizeInKbs >= 1024) {
    return `${(sizeInKbs / 1024)?.toFixed(2)} MB`;
  }
  return `${sizeInKbs?.toFixed(2)} KB`;
};

const mapApiDocToTableDoc = (
  doc: KnowledgeBaseDocumentAPI,
  index: number
): HelpDeskDocument => ({
  id: doc?._id ?? `api-doc-${index}`,
  fileName: doc?.file_name,
  systemName: (doc?.category_name || "concurrent") as SystemName,
  fileSize: formatFileSize(doc?.file_size_in_kbs),
  uploadedBy: doc?.created_by?.name || "",
  uploadedAt:
    getDateTimeByFormat(new Date(doc?.created_at))?.date +
    ", " +
    getDateTimeByFormat(new Date(doc?.created_at))?.time,
  category: doc?.category,
});

const SORT_FIELD_TO_API: Record<string, string> = {
  fileName: "file_name",
  uploadedAt: "updated_at",
};

const ManageDocumentsTable = ({
  title = "Manage All Documents",
  systemNameFilter,
  categoryFilter,
  categoriesData = [],
}: ManageDocumentsTableProps) => {
  const [searchInput, setSearchInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const {
    page: currentPage,
    setPage: setCurrentPage,
    limit: itemsPerPage,
    setLimit: setItemsPerPage,
  } = usePersistedPagination("helpdesk-kb-manage-docs");
  const [sortOrder, setSortOrder] = useSessionStorageState<"asc" | "desc">(
    "helpdesk-kb-manage-docs:sortOrder",
    "desc"
  );
  const [sortField, setSortField] = useSessionStorageState<
    "fileName" | "uploadedAt"
  >("helpdesk-kb-manage-docs:sortField", "uploadedAt");
  const [openMenuId, setOpenMenuId] = useState<string | null>(null);

  // const [reuploadDoc, setReuploadDoc] = useState<HelpDeskDocument | null>(null);
  // const [isReuploading, setIsReuploading] = useState(false);
  const [deleteDocData, setDeleteDocData] = useState<HelpDeskDocument | null>(
    null
  );
  const [isDeletingDocument, setIsDeletingDocument] = useState(false);
  const [previewDoc, setPreviewDoc] = useState<HelpDeskDocument | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string>("");

  const [showSystemFilter, setShowSystemFilter] = useState(false);
  const [selectedSystems, setSelectedSystems] = useState<SystemName[]>([]);
  const [pendingSystems, setPendingSystems] = useState<SystemName[]>([]);
  const systemFilterRef = useRef<HTMLDivElement>(null);
  const systemFilterBtnRef = useRef<HTMLButtonElement>(null);

  const activeCategories: string[] = categoryFilter
    ? [categoryFilter]
    : systemNameFilter
      ? [systemNameFilter]
      : selectedSystems;

  const [deleteDocument] = useDeleteKnowledgeBaseDocumentMutation();
  const [getPreviewUrl] = useLazyGetKnowledgeBaseDocumentPreviewUrlQuery();

  const {
    data: apiResponse,
    isLoading: isLoadingDocuments,
    refetch,
  } = useGetKnowledgeBaseDocumentsQuery({
    skip: (currentPage - 1) * itemsPerPage,
    limit: itemsPerPage,
    sort_by: SORT_FIELD_TO_API[sortField] || "updated_at",
    sort_order: sortOrder,
    search: searchQuery || undefined,
    categories: activeCategories?.length > 0 ? activeCategories : undefined,
  });

  const tableDocuments: HelpDeskDocument[] = useMemo(() => {
    if (apiResponse?.documents && apiResponse?.documents?.length > 0) {
      return apiResponse?.documents?.map(mapApiDocToTableDoc);
    }
    // return DUMMY_DOCUMENTS.slice(
    //   (currentPage - 1) * itemsPerPage,
    //   currentPage * itemsPerPage
    // );
    return [];
  }, [apiResponse, currentPage, itemsPerPage]);

  const totalCount = apiResponse?.count_of_documents ?? 0;
  const totalPages = Math.ceil(totalCount / itemsPerPage);

  const applySystemFilter = useCallback(() => {
    setSelectedSystems(pendingSystems);
    setShowSystemFilter(false);
    setCurrentPage(1);
  }, [pendingSystems, setCurrentPage]);

  const cancelSystemFilter = useCallback(() => {
    setSelectedSystems([]);
    setPendingSystems([]);
    setShowSystemFilter(false);
  }, []);

  const togglePendingSystem = useCallback((name: SystemName) => {
    setPendingSystems((prev) =>
      prev?.includes(name) ? prev?.filter((s) => s !== name) : [...prev, name]
    );
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        showSystemFilter &&
        systemFilterRef.current &&
        !systemFilterRef.current.contains(e.target as Node) &&
        systemFilterBtnRef.current &&
        !systemFilterBtnRef.current.contains(e.target as Node)
      ) {
        setShowSystemFilter(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showSystemFilter]);

  useEffect(() => {
    if (showSystemFilter) {
      const handleScroll = (e: Event) => {
        e?.preventDefault();
        e?.stopPropagation();
      };
      window.addEventListener("scroll", handleScroll, {
        passive: false,
        capture: true,
      });
      window.addEventListener("wheel", handleScroll, {
        passive: false,
        capture: true,
      });
      return () => {
        window.removeEventListener("scroll", handleScroll, true);
        window.removeEventListener("wheel", handleScroll, true);
      };
    }
  }, [showSystemFilter]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSearchQuery(searchInput);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [searchInput]);

  const handleSearchInputChange = useCallback(
    (value: string) => {
      setSearchInput(value);
      setCurrentPage(1);
    },
    [setCurrentPage]
  );

  const handleRowsPerPageChange = useCallback(
    (size: number) => {
      setItemsPerPage(size);
      setCurrentPage(1);
    },
    [setItemsPerPage, setCurrentPage]
  );

  const handleSort = useCallback(
    (field: "fileName" | "uploadedAt") => {
      if (sortField === field) {
        setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
      } else {
        setSortField(field);
        setSortOrder("asc");
      }
      setCurrentPage(1);
    },
    [sortField, setSortField, setSortOrder, setCurrentPage]
  );

  // const handleReingestDocument = useCallback(async (_docId: string, _files: File[]) => {
  //   setIsReuploading(true);
  //   try {
  //     // TODO: integrate actual reupload API call
  //   } finally {
  //     setIsReuploading(false);
  //     setReuploadDoc(null);
  //   }
  // }, []);

  const handlePreviewDocument = useCallback(
    async (doc: HelpDeskDocument, isDownload: boolean = false) => {
      setOpenMenuId(null);
      try {
        const result = await getPreviewUrl({
          documentId: doc.id,
          isPreview: isDownload ? false : true,
        }).unwrap();
        if (isDownload) {
          window.open(result?.url || "", "_blank");
        } else {
          setPreviewUrl(result?.preview_url || result?.url || "");
        }
      } catch {
        setPreviewUrl("");
      }
      if (!isDownload) {
        setPreviewDoc(doc);
      }
    },
    [getPreviewUrl]
  );

  const handleDeleteDocument = useCallback(async () => {
    if (!deleteDocData) return;
    setIsDeletingDocument(true);
    try {
      await deleteDocument(deleteDocData?.id).unwrap();
      refetch();
    } catch (err) {
      console.error("Failed to delete document:", err);
    } finally {
      setIsDeletingDocument(false);
      setDeleteDocData(null);
    }
  }, [deleteDocData, deleteDocument, refetch]);

  const COLUMNS: ColumnDef<HelpDeskDocument>[] = useMemo(
    () => [
      {
        accessorKey: "file_icon",
        size: 30,
        header: () => (
          <div className="flex items-center justify-center h-[34px] px-3">
            <GalleryIcon className="w-[14px] h-[14px] text-gray-375 dark:text-gray-375-dk" />
          </div>
        ),
        cell: ({ row }) => {
          const doc = row?.original;
          const iconSrc = getFileTypeIcon(doc?.fileName);
          return (
            <div className="flex items-center justify-center mx-3">
              <img src={iconSrc} alt={doc?.fileName} className="w-6 h-6" />
            </div>
          );
        },
      },
      {
        accessorKey: "fileName",
        minSize: 300,
        header: () => (
          <div
            className="flex items-center gap-0 h-[34px] px-3 cursor-pointer"
            onClick={() => handleSort("fileName")}
          >
            <span className="text-md font-medium text-gray-375 dark:text-gray-375-dk capitalize">
              Document Name
            </span>
            <SortByIcon className="w-4 h-4 text-verba-blue dark:text-verba-blue-dk" />
          </div>
        ),
        cell: ({ row }) => (
          <div className="px-2">
            <span
              className="text-md font-medium text-heading-text dark:text-heading-text-dk hover:underline cursor-pointer"
              onClick={() => handlePreviewDocument(row?.original)}
            >
              {row?.original?.fileName}
            </span>
          </div>
        ),
      },
      {
        accessorKey: "systemName",
        size: 160,
        maxSize: 200,
        header: () => (
          <div className="flex items-center h-[34px] px-3">
            <span className="text-md font-medium text-gray-375 dark:text-gray-375-dk capitalize">
              System Name
            </span>
            {categoriesData?.length > 0 && (
              <button
                ref={systemFilterBtnRef}
                type="button"
                onClick={() => setShowSystemFilter(!showSystemFilter)}
                className="ml-0.5"
              >
                <SortByIcon className="w-4 h-4 text-verba-blue dark:text-verba-blue-dk" />
              </button>
            )}
            {showSystemFilter &&
              createPortal(
                <div
                  ref={systemFilterRef}
                  className="fixed z-[100] backdrop-blur-[20px] bg-popper-bg dark:bg-popper-bg-dk border border-border-gray dark:border-border-gray-dk flex flex-col overflow-hidden rounded-[8px] shadow-[10px_10px_60px_0px_rgba(0,0,0,0.2)] w-[200px]"
                  style={{
                    top:
                      (systemFilterBtnRef.current?.getBoundingClientRect()
                        .bottom ?? 0) + 4,
                    left:
                      systemFilterBtnRef.current?.getBoundingClientRect()
                        .left ?? 0,
                  }}
                >
                  <div className="flex flex-col gap-0.5 items-start justify-center px-3 py-3">
                    <p className="text-sm font-semibold text-dark-gray dark:text-dark-gray-dk uppercase">
                      System name
                    </p>
                  </div>

                  <div className="flex flex-col flex-1 min-h-0 overflow-y-auto max-h-[180px]">
                    {categoriesData?.map((category) => {
                      const systemId = category?.id as SystemName;
                      const isChecked = pendingSystems?.includes(systemId);
                      return (
                        <button
                          key={category.id}
                          type="button"
                          onClick={() => togglePendingSystem(systemId)}
                          className="flex items-center justify-between px-3 py-2 h-9 border-b border-border-gray dark:border-border-gray-dk hover:bg-hover-effect dark:hover:bg-hover-effect-dk transition-colors"
                        >
                          <div className="inline-flex items-center gap-1 max-w-[140px] px-2 py-0.5 rounded-[6px] border border-border-gray dark:border-border-gray-dk bg-pure-white dark:bg-pure-white-dk shadow-xs-blur">
                            {renderSystemIcon(systemId)}
                            <span className="text-md font-medium text-verba-indigo dark:text-verba-indigo-dk leading-[18px] truncate">
                              {category?.title}
                            </span>
                          </div>
                          <div
                            className={`w-3.5 h-3.5 rounded-[3px] border shrink-0 flex items-center justify-center cursor-pointer ${
                              isChecked
                                ? "bg-verba-blue border-verba-blue dark:bg-verba-blue-dk dark:border-verba-blue-dk"
                                : "bg-popper-bg dark:bg-popper-bg-dk border-gray-placeholder dark:border-gray-placeholder-dk"
                            }`}
                          >
                            {isChecked && (
                              <CheckIcon className="w-4 h-4 text-white dark:text-white" />
                            )}
                          </div>
                        </button>
                      );
                    })}
                  </div>

                  <div className="flex items-center gap-2 h-10 px-3">
                    <Button
                      innerText="Cancel"
                      onClick={cancelSystemFilter}
                      buttonContainerClass="flex-1 h-[26px] text-xs font-semibold text-heading-text dark:text-heading-text-dk rounded-[6px] hover:bg-hover-effect dark:hover:bg-hover-effect-dk transition-colors"
                    />
                    <Button
                      type="button"
                      onClick={applySystemFilter}
                      buttonContainerClass="h-[26px] flex-1 bg-verba-indigo dark:bg-verba-indigo-dk rounded-[6px] hover:bg-verba-blue dark:hover:bg-verba-blue-dk transition-colors"
                      innerTextClass="text-xs font-semibold text-pure-white dark:text-pure-white-dk"
                      innerText="Apply"
                    />
                  </div>
                </div>,
                document.body
              )}
          </div>
        ),
        cell: ({ row }) => (
          <div className="px-2">
            <div className="inline-flex items-center gap-1 max-w-[140px] px-2 py-0.5 rounded-[6px] border border-border-gray dark:border-border-gray-dk bg-pure-white dark:bg-pure-white-dk shadow-xs-blur">
              {renderSystemIcon(row?.original?.category as SystemName)}
              <span className="text-md font-medium text-verba-indigo dark:text-verba-indigo-dk leading-[18px] truncate">
                {row?.original?.systemName}
              </span>
            </div>
          </div>
        ),
      },
      {
        accessorKey: "fileSize",
        size: 80,
        maxSize: 110,
        header: () => (
          <div className="flex items-center h-[34px] px-2">
            <span className="text-md font-medium text-gray-375 dark:text-gray-375-dk capitalize">
              File Size
            </span>
          </div>
        ),
        cell: ({ row }) => (
          <div className="px-2">
            <span className="text-sm font-normal text-dark-gray dark:text-dark-gray-dk">
              {row?.original?.fileSize}
            </span>
          </div>
        ),
      },
      {
        accessorKey: "uploadedAt",
        size: 140,
        maxSize: 200,
        header: () => (
          <div
            className="flex items-center gap-0 h-[34px] px-2 cursor-pointer"
            onClick={() => handleSort("uploadedAt")}
          >
            <span className="text-md font-medium text-gray-375 dark:text-gray-375-dk capitalize">
              Uploaded
            </span>
            <SortByIcon className="w-4 h-4 text-verba-blue dark:text-verba-blue-dk" />
          </div>
        ),
        cell: ({ row }) => {
          const doc = row?.original;
          return (
            <div className="flex flex-col gap-0.5 px-2">
              <div className="flex items-center gap-1">
                <Avatar
                  text={doc?.uploadedBy}
                  size={18}
                  maxChars={1}
                  className="text-sm"
                />
                <span className="text-xs font-medium text-verba-indigo dark:text-verba-indigo-dk truncate">
                  {doc?.uploadedBy}
                </span>
              </div>
              <span className="text-xs font-medium text-data dark:text-data-dk">
                {doc?.uploadedAt}
              </span>
            </div>
          );
        },
      },
      {
        accessorKey: "actions",
        size: 42,
        header: () => <div className="h-[34px]" />,
        cell: ({ row }) => {
          const doc = row?.original;
          const isOpen = openMenuId === doc?.id;

          const actionOptions: ActionOption[] = [
            // {
            //   innerText: "Reupload",
            //   Icon: ReUploadIcon,
            //   iconClass:
            //     "w-4.5 h-4.5 text-verba-indigo dark:text-verba-indigo-dk",
            //   innerTextClass:
            //     "text-md text-heading-text dark:text-heading-text-dk",
            //   buttonContainerClass: "justify-start w-full ml-2",
            //   onClick: () => {
            //     setOpenMenuId(null);
            //     setReuploadDoc(doc);
            //   },
            // },
            {
              innerText: "Preview",
              Icon: PreviewIcon,
              iconClass:
                "w-4.5 h-4.5 text-verba-indigo dark:text-verba-indigo-dk",
              innerTextClass:
                "text-md text-heading-text dark:text-heading-text-dk",
              buttonContainerClass: "justify-start w-full ml-2",
              onClick: () => handlePreviewDocument(doc),
            },
            {
              innerText: "Download",
              Icon: DownloadIcon,
              iconClass:
                "w-4.5 h-4.5 text-verba-indigo dark:text-verba-indigo-dk",
              innerTextClass:
                "text-md text-heading-text dark:text-heading-text-dk",
              buttonContainerClass: "justify-start w-full ml-2",
              onClick: () => handlePreviewDocument(doc, true),
            },
            {
              innerText: "Delete",
              Icon: TrashIcon,
              iconClass:
                "w-4.5 h-4.5 text-verba-red-alert dark:text-verba-red-alert-dk",
              innerTextClass:
                "text-md text-verba-red-alert dark:text-verba-red-alert-dk",
              buttonContainerClass: "justify-start w-full ml-2",
              onClick: () => {
                setOpenMenuId(null);
                setDeleteDocData(doc);
              },
            },
          ];

          return (
            <ActionsCellComponent
              rowId={doc?.id}
              isOpen={isOpen}
              setOpenMenuId={setOpenMenuId}
              actionOptions={actionOptions}
            />
          );
        },
      },
    ],
    [
      handleSort,
      openMenuId,
      showSystemFilter,
      pendingSystems,
      cancelSystemFilter,
      applySystemFilter,
      togglePendingSystem,
      handlePreviewDocument,
      categoriesData,
    ]
  );

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1.5">
          <h3 className="text-base font-medium text-heading-text dark:text-heading-text-dk">
            {title}
          </h3>
          <div className="flex items-center">
            <span className="border border-gray-100 dark:border-gray-100-dk rounded px-1 py-0.5 text-xxs font-semibold text-verba-indigo dark:text-verba-indigo-dk leading-normal">
              {totalCount}
            </span>
          </div>
        </div>
        <div className="flex items-center gap-1 h-[26px] w-[240px] px-1.5 py-2 rounded-[6px] border border-border-gray dark:border-border-gray-dk bg-popper-bg dark:bg-popper-bg-dk">
          <SearchIcon className="w-[14px] h-[14px] text-verba-indigo dark:text-verba-indigo-dk shrink-0" />
          <input
            type="text"
            placeholder="Search documents"
            value={searchInput}
            onChange={(e) => handleSearchInputChange(e.target.value)}
            className="flex-1 bg-transparent outline-none border-none text-md font-normal text-heading-text dark:text-heading-text-dk placeholder:text-gray-placeholder dark:placeholder:text-gray-placeholder-dk"
          />
        </div>
      </div>
      <Table
        COLUMNS={COLUMNS}
        COLUMNS_DATA={tableDocuments}
        cellClassName="!h-[50px] !px-0"
        ariaLabel="Helpdesk documents table"
        isLoading={isLoadingDocuments}
        maxHeight="523px"
        extraClass="min-h-[523px] overflow-y-auto no-scrollbar"
      />
      {totalPages > 0 && (
        <Pagination
          rowsPerPage={itemsPerPage}
          handleRowsPerPageChange={handleRowsPerPageChange}
          currentPage={currentPage}
          handlePageChange={setCurrentPage}
          totalPages={totalPages}
          visiblePages={Array.from({ length: totalPages }, (_, i) => i + 1)}
        />
      )}

      {/* <ReuploadDocModal
        open={!!reuploadDoc}
        onOpenChange={(open) => {
          if (!open) setReuploadDoc(null);
        }}
        fileName={reuploadDoc?.fileName ?? ""}
        docId={reuploadDoc?.id ?? ""}
        isReuploading={isReuploading}
        onReingestDocument={handleReingestDocument}
        propertyId={reuploadDoc?.systemName ?? ""}
        propertyName={reuploadDoc?.systemName ?? ""}
      /> */}

      <DeleteDocumentModal
        open={deleteDocData ? "deleteFromLive" : null}
        onOpenChange={(val) => {
          if (!val) setDeleteDocData(null);
        }}
        handleDeleteDocument={handleDeleteDocument}
        isDeletingDocument={isDeletingDocument}
        documentName={deleteDocData?.fileName ?? ""}
      />

      {previewDoc && (
        <DocPreviewer
          documentUrl={previewUrl}
          title={previewDoc?.fileName}
          setShowPreviewer={(show) => {
            if (!show) {
              setPreviewDoc(null);
              setPreviewUrl("");
            }
          }}
        />
      )}
    </div>
  );
};

export default ManageDocumentsTable;
